export const learning_path='learning-path'
export const soul ='soul'
export const home ='home'
export const mapp_learning_path_routes ={
learning_path:`/${home}/${learning_path}`,
soul_learning_home:`/${home}/${learning_path}/${soul}`,
soul_learning_path:`/${soul}/${learning_path}`
}

export default mapp_learning_path_routes 